<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DateRangePicker1',
})
</script>
<template>
  <DatePicker.RangePicker
    :popupClassName="bem()"
    :disabled-date="disabledDate"
    :show-time="{ format: 'HH:mm:ss' }"
    :allow-clear="false"
    format="YYYY年MM月DD日 HH:mm:ss"
    v-bind="$attrs"
    :ranges="DATE_RANGE_PRESETS"
  >
    <template #suffixIcon>
      <CalendarOutlined />
    </template>
  </DatePicker.RangePicker>
</template>

<script lang="ts" setup name="DateRangePicker1">
import { CalendarOutlined } from '@ant-design/icons-vue'
import { DatePicker } from 'ant-design-vue'
import dayjs, { Dayjs } from 'dayjs'
import { createNamespace } from '@bd/vue3-utils'
const [_, bem] = createNamespace('DateRangePicker1')

const DATE_RANGE_PRESETS: any = {
  本周: [dayjs().startOf('week'), dayjs().endOf('week')],
  上周: [dayjs().add(-1, 'w').startOf('week'), dayjs().add(-1, 'w').endOf('week')],
  本月: [dayjs().startOf('month'), dayjs().endOf('month')],
  上月: [dayjs().add(-1, 'M').startOf('month'), dayjs().add(-1, 'M').endOf('month')],
  近三月: [dayjs().add(-3, 'M'), dayjs()],
  近六月: [dayjs().add(-6, 'M'), dayjs()],
  近一年: [dayjs().add(-1, 'y'), dayjs()]
}
const disabledDate = (current: Dayjs) => current.valueOf() > Date.now()
</script>
<style lang="less">
.date-range-picker1 {
  &.ant-picker {
    width: 100%;

    &-dropdown-range {
      .ant-picker-preset {
        .ant-tag-blue {
          border-color: #e6f6ff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
